// src/components/profile/ProfileHeader.jsx
import React from "react";
import { Typography, Box, useTheme, useMediaQuery } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle"; // Icon for profile

const ProfileHeader = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <Box textAlign="center" mb={isMobile ? 3 : 5} px={isMobile ? 2 : 0}>
      <Typography
        variant={isMobile ? "h4" : "h3"}
        component="h1"
        gutterBottom
        fontWeight="bold"
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexWrap: "wrap",
          gap: 1,
          color: theme.palette.text.primary, // Ensure text color adapts to theme
        }}
      >
        <AccountCircleIcon
          sx={{
            fontSize: isMobile ? 32 : 40,
            verticalAlign: "middle",
            color: theme.palette.primary.main, // Icon color
          }}
        />
        <span>My Profile</span>
      </Typography>
      <Typography
        variant={isMobile ? "body1" : "h6"}
        color="text.secondary" // Use text.secondary for subtle text
        maxWidth={isTablet ? "90%" : "800px"}
        mx="auto"
        sx={{
          fontSize: isMobile ? "1rem" : undefined,
          lineHeight: isMobile ? 1.5 : undefined,
          px: isMobile ? 1 : 0,
        }}
      >
        Manage your account information, certifications, dive-related content,
        and display preferences.
      </Typography>
    </Box>
  );
};

export default ProfileHeader;
